module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dEQlST/tc-custom/9798889102243.jpg?1720272536027",
      "alt": "This image is the cover for the book Labyrinth"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Labyrinth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("When everyday people find themselves trapped in unthinkable circumstances, they discover reserves of courage that transform them in profound ways. This gripping tale pulls back the curtain on a hidden world, one where the influential and privileged prey upon the defenceless. As the characters navigate this treacherous maze, they are forced to confront the darkest corners of humanity and summon the heroism within themselves. "), _c('em', [_vm._v("Labyrinth")]), _vm._v(" is a heart-pounding exploration into the complexity of morality and the depths of depravity that will leave readers questioning where the monsters end and the humans begin.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gregory Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Gregory lives in Virginia with his wife, Carithia.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("He is a retired executive with AT&T.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("He has a love of music and sports.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0